import Vue from 'vue'

import _Notes from './Notes'

export const Notes = Vue.component('notes', _Notes);

